import React from 'react';
import CustomOfferConfirmStep from './CustomOfferConfirmStep';
import css from './TransactionPanel.css';

const row = (label, value) => (
  <div className={css.modalPricingRow}>
    <span className={css.modalPricingLabel}>{label}</span>
    <span className={css.modalPricingValue}>{value}</span>
  </div>
);
const pricingBox = (
  <div className={css.modalPricingBox}>
    {row('Freelancerin työ (ALV 0 %)', '2 125,00 €')}
    {row('Freedomlyn palvelumaksu (15 %)', '375,00 €')}
    {row('ALV 25,5 %', '637,50 €')}
    <div className={css.modalPricingRowTotal}>
      <span className={css.modalPricingLabelTotal}>Yhteensä</span>
      <span className={css.modalPricingValueTotal}>3 137,50 €</span>
    </div>
  </div>
);
const base = {
  offerTitle: 'Verkkosivujen uudistus ja SEO-optimointi',
  paymentTermDays: 14,
  onBack: () => null,
  onAccept: () => null,
};

export const Ready = {
  component: CustomOfferConfirmStep,
  props: { ...base, pricingBox },
  group: 'transaction',
};

export const Checking = {
  component: CustomOfferConfirmStep,
  props: { ...base, checking: true, acceptDisabled: true },
  group: 'transaction',
};
